import {ApiException} from "@/domain/core/exception/exceptions";
import {emptyListResponse} from "@/domain/core/utils/django";

const state = {
    payouts: {...emptyListResponse},
    payout: null,
}

export const getters = {
    payouts: state => state.payouts,
    payout: state => state.payout,
}

export const mutations = {
    payouts(state, payouts) {
        state.payouts = payouts
    },
    payout(state, payout) {
        state.payout = payout
        // Update the payout in the list if it exists
        if (state.payouts.results) {
            state.payouts.results = state.payouts.results.map(p => {
                if (p.id === payout.id)
                    return payout
                return p
            })
        }
    }
}

export const actions = service => ({
    async fetchAdminPayoutList({commit}, {filters, pagination, sorting}) {
        try {
            const payouts = await service.fetchAdminPayoutList(filters, pagination, sorting)
            commit('payouts', payouts)
            return payouts
        } catch (e) {
            throw new ApiException(e)
        }
    },
    
    async fetchAdminPayoutDetail({commit}, id) {
        try {
            const payout = await service.fetchAdminPayoutDetail(id)
            commit('payout', payout)
            return payout
        } catch (e) {
            throw new ApiException(e)
        }
    },
    
    async markPayoutAsPaid({commit, dispatch}, {id, data}) {
        try {
            const result = await service.markPayoutAsPaid(id, data)
            // Update the payout in the store
            await dispatch('fetchAdminPayoutDetail', id)
            return result
        } catch (e) {
            throw new ApiException(e)
        }
    },
    
    async downloadPayoutExcel({}, id) {
        try {
            return await service.downloadPayoutExcel(id)
        } catch (e) {
            throw new ApiException(e)
        }
    },
    
    async deleteLastPayout({dispatch}, id) {
        try {
            await service.deleteLastPayout(id)
            // Refresh the list after deletion
            await dispatch('fetchAdminPayoutList', {
                filters: {},
                pagination: { page_size: 20, page: 1 },
                sorting: { column: null, asc: false }
            })
        } catch (e) {
            throw new ApiException(e)
        }
    }
})

export default adminPayoutService => ({
    namespaced: true,
    state,
    getters,
    mutations,
    actions: actions(adminPayoutService)
})